module.exports = __webpack_public_path__ + "img/coin2.83610ee.webp";